/* Lightweight progressive loader; the large scene is never required for content. */
(() => {
  if (window.PineConnectorSignalField) return;
  const mounted = new Map();
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  const constrained = () => !!navigator.connection?.saveData;
  let modulePromise;
  function mount(root) {
    if (mounted.has(root)) return;
    const record = { observer: null, scene: null, disposed: false };
    mounted.set(root, record);
    root.dataset.renderer = 'static';
    const journey = root.closest('[data-signal-journey]');
    if (journey) journey.dataset.renderer = 'static';
    const setSceneState = state => {
      root.dataset.sceneState = state;
      if (journey) journey.dataset.sceneState = state;
    };
    const policy = root.dataset.motion === 'static' ? 'static' : reduced.matches ? 'reduced-motion' : constrained() ? 'save-data' : 'adaptive';
    root.dataset.motionPolicy = policy;
    setSceneState(policy === 'adaptive' ? 'loading' : 'static');
    if (policy !== 'adaptive') return;
    record.observer = new IntersectionObserver(async ([entry]) => {
      if (!entry.isIntersecting || record.disposed) return;
      record.observer.disconnect();
      try {
        modulePromise ||= import(root.dataset.sceneUrl);
        const module = await modulePromise;
        if (record.disposed || reduced.matches || !root.isConnected) return;
        record.scene = module.createSignalField(root);
        if (root.dataset.renderer !== 'webgl') setSceneState('static');
      } catch (error) {
        if (record.disposed || !root.isConnected) return;
        root.dataset.renderer = 'static';
        if (journey) journey.dataset.renderer = 'static';
        setSceneState('static');
        console.warn('PineConnector: using static signal composition.', error.message);
      }
    }, { rootMargin: '160px' });
    record.observer.observe(journey || root);
  }
  function unmount(root) {
    const record = mounted.get(root);
    if (!record) return;
    record.disposed = true;
    record.observer?.disconnect();
    record.scene?.dispose();
    mounted.delete(root);
  }
  function landmarks() {
    const host = document.querySelector('[data-signal-journey]');
    if (!host) return;
    const labels = {pc_brokers_a:'Brokers',pc_signal_route:'The route',pc_hero_gb61:'How it works',pc_bridge_cmd_v1:'The command',pc_bridge_edge_f11:'Hosted MT5',pc_edge_s2:'Your portal',pc_mid_cta_lab:'Your time',pc_flow_tools:'Your tools',pc_customer_outcomes:'Customer stories',pc_flow_readiness:'Your first setup',pc_flow_pricing:'Your plan',pc_flow_questions:'Your questions',pc_flow_final:'Your foundation'};
    host.querySelectorAll('#MainContent > .shopify-section').forEach(el => {
      const key = el.id.split('__').pop();
      if (labels[key]) { el.dataset.signalChapter = key; el.dataset.signalLabel = labels[key]; }
    });
    const footer = host.querySelector('[id$="pc-footer-b4"]');
    if (footer) { footer.dataset.signalChapter = 'footer'; footer.dataset.signalLabel = 'The connection continues'; }
  }
  function scan(scope = document) { landmarks(); scope.querySelectorAll('[data-signal-field]').forEach(mount); }
  function rebuild() { const roots = [...mounted.keys()]; roots.forEach(unmount); roots.forEach(mount); }
  reduced.addEventListener('change', rebuild);
  document.addEventListener('shopify:section:load', (event) => { scan(event.target); if (event.target.querySelector('[data-signal-flow]')) rebuild(); requestAnimationFrame(() => mounted.forEach(record => record.scene?.refresh())); });
  document.addEventListener('shopify:section:unload', (event) => { event.target.querySelectorAll('[data-signal-field]').forEach(unmount); requestAnimationFrame(() => mounted.forEach(record => record.scene?.refresh())); });
  document.addEventListener('shopify:section:reorder', () => mounted.forEach(record => record.scene?.refresh()));
  window.addEventListener('pagehide', () => mounted.forEach(record => record.scene?.suspend()));
  window.addEventListener('pageshow', () => mounted.forEach(record => record.scene?.resume()));
  window.PineConnectorSignalField = { scan };
  scan();
})();
